import { getI18n } from 'react-i18next';

import Config from '../../../../Config';
import Logger from '../../../../lib/Logger';
import Events from '../../../../lib/EventEmitter';

import LearningsAdminScreen from './containers/LearningsAdminScreenContainer';
import LearningAdminModuleSerieAddScreen from './containers/LearningAdminModuleSerieAddScreenContainer';
import LearningAdminModuleSerieEditScreen from './containers/LearningAdminModuleSerieEditScreenContainer';

import LearningAdminModuleAddScreen from './containers/LearningAdminModuleAddScreenContainer';
import LearningAdminModuleEditScreen from './containers/LearningAdminModuleEditScreenContainer';

const register = () => {
  Logger.log('debug', `learningsAdmin.register()`);

  if (Config.getIn(['MODULE_TOGGLES', 'learningsAdmin', 'routes'])) {
    Events.dispatch('ADD_ADMIN_ROUTES', {
      LearningAdminModuleSerieAddScreen: [
        'PrivateRoute',
        '/admin/learnings/module-serie/partnership/:id_partnership([\\w\\-]+)/add',
        true,
        LearningAdminModuleSerieAddScreen,
        getI18n().t('learnings_route_add'),
      ],
      LearningAdminModuleSerieEditScreen: [
        'PrivateRoute',
        '/admin/learnings/module-serie/partnership/:id_partnership([\\w\\-]+)/edit/:id([\\w\\-]+)',
        true,
        LearningAdminModuleSerieEditScreen,
        getI18n().t('learnings_route_edit'),
      ],
      LearningAdminModuleAddScreen: [
        'PrivateRoute',
        '/admin/learnings/module/partnership/:id_partnership([\\w\\-]+)/add',
        true,
        LearningAdminModuleAddScreen,
        getI18n().t('learnings_route_add'),
      ],
      LearningAdminModuleEditScreen: [
        'PrivateRoute',
        '/admin/learnings/module/partnership/:id_partnership([\\w\\-]+)/edit/:id([\\w\\-]+)',
        true,
        LearningAdminModuleEditScreen,
        getI18n().t('learnings_route_edit'),
      ],
      LearningsAdminScreen: [
        'PrivateRoute',
        '/admin/learnings/:page(\\d+)?',
        true,
        LearningsAdminScreen,
        getI18n().t('learnings_route_list'),
      ],
    });
  }
};

export default register;

Logger.log('silly', `learningsAdmin.register() loaded.`);
